import "./style.css";
import App from "./scene/app.js";
console.log("app", App);
const app = new App(document.querySelector("#app"));
